import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class AdminConfigService extends RLBaseService {

	static $inject = ["$resource", "$q"];

	constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
		super($resource);
	}

	deleteCurrencyConversionInfo(id: string) {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/CurrencyConversion/deleteCurrencyConversionInfo").delete({ currencyConversionInfoID: id }).$promise;
	}

	uploadCurrencyConversionInfo(currencyConversionFileName: string) {
		var data = { fileName: currencyConversionFileName };
		return this.toRLService<{ [key: number]: string }>("/api/CurrencyConversion/UploadCurrencyConversionFile").post(data).$promise;
	}

	getCurrencyConversionList(getHistoricData: boolean) {
		return this.toRLService<Models.ICurrencyConversionInfo>("/api/CurrencyConversion/GetCurrencyConversionList").query({ getHistoricData: getHistoricData }).$promise;
	}

	createCurrencyConversionInfo(createCurrencyConversionInfo: Models.ICurrencyConversionInfo) {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/CurrencyConversion/CreateCurrencyConversionInfo").post(createCurrencyConversionInfo).$promise;
	}

	updateCurrencyConversionInfo(editCurrencyConversionInfo: Models.ICurrencyConversionInfo) {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/CurrencyConversion/updateCurrencyConversionInfo").post(editCurrencyConversionInfo).$promise;
	}

	validateBulkUpdateStatusRecords(char: string, template: string, rec: string) {
		var data = {
			charTypeID: char,
			recIDs: rec,
			templateID: template
		}
		return this.toRLService <Models.IDataResponse<Models.IValidateRecIDsOrTitlesResponse[]>>("/api/admin/ValidateBulkStatusUpdateRecords").post(data).$promise;
	}

	bulkUpdateStatus(char: string, rec: string, staID: string, staLabel: string, template: string) {
		var data = {
			charTypeID: char,
			recIDs: rec,
			templateID: template,
			staID: staID,
			staLabel: staLabel
		}
		return this.toRLService<Models.IJobResponse>("/api/admin/UpdateRecordStatusBulk").post(data).$promise;
	}

	createDivSetting(createDivSettingInfo: Models.IDivSetting) {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/CreateDivSettingList").post(createDivSettingInfo).$promise;
	}

	createBillID() {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/CreateBillingID").post().$promise;
	}

	updateDivSetting(updateDivSettingInfo: Models.IDivSetting) {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/UpdateDivSettingList").post(updateDivSettingInfo).$promise;
	}

	getDivSettingList() {
		return this.toRLService<Models.IDivSetting>("/api/admin/GetDivSettingList").query().$promise;
	}

	deleteDivSetting(divSettingID: string) {
		return this.toRLService<void>("/api/admin/DeleteDivSettingList").delete({ divSettingID: divSettingID }).$promise;
	}

	GetEntityCharTypes() {
		return this.toRLService<Models.IKeyValuePair<string, string>>("/api/admin/GetCharTypeSorted").query().$promise;
	}

	GetCharTypeTemplate(charType: string, userFlag: string) {
		var data = {
			charTypeID: charType,
			userFlag: userFlag
		}
		return this.toRLService<Models.IEntityCharTypeTemplate>("/api/admin/GetCharacteristicTemplate").query(data).$promise;
	}

	IsUserAppUser(email: string) {
		var data = {
			email: email
		};
		return this.toRLService<{ success: boolean }>("/api/admin/IsUserAppUser").get(data).$promise;
	}

	IsEmailValidForAppLogin(email: string) {
		var data = {
			email: email
		};
		return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/IsEmailValidForAppLogin").get(data).$promise;
	}


	ShowUserConflictMessageForContact(email: string, userRecordID: number) {
		var data = {
			email: email,
			userRecordID: userRecordID
		};
		return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/ShowUserConflictMessageForContact").get(data).$promise;
	}

	GetTemplateStatus(charType: string, templateType: string) {
		var data = {
			charID: charType,
			templateID: templateType
		}
		return this.toRLService<Models.IEntityStatus>("/api/admin/GetCharacteristicTemplateStatusList").query(data).$promise;
	}

	getCompanyCurrency() {
		return this.toRLService<Models.IDataResponse<string>>("/api/CurrencyConversion/GetCompanyCurrency").get().$promise;
	}

	getCompanyCurrencyValueList() {
		return this.toRLService<Models.ICharacteristicValue>("/api/CurrencyConversion/getCompanyCurrencyValueList").query().$promise;
	}

	adminEmail(email: string) {
		var data = {
			email: email
		};
		return this.toRLService<{ success: boolean }>("/api/admin/ValidUserAdmin").get(data).$promise;

	}

	getGetStandardCurrencyList() {
		return this.toRLService<Models.ICharacteristicValue>("/api/CurrencyConversion/GetStandardCurrencyList").query().$promise;
	}

	isRLUser() {
		return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/IsRLUser").get().$promise;
	}

	getAmortizationList() {
		return this.toRLService<Models.IDataResponse<Models.AmortizationModel[]>>("/api/Amortization/GetAmortizationList").get().$promise;
	}

	getAmortizationModel(id: number) {
		return this.toRLService<Models.IDataResponse<Models.AmortizationModel>>("/api/Amortization/GetAmortizationModel").get(id).$promise;
	}

	deleteAmortizationModel(id: number) {
		return this.toRLService<Models.IDataResponse<void>>("/api/Amortization/DeleteAmortizationModel").delete({ id }).$promise;
	}

	editAmortizationModel(model: Models.AmortizationModel) {
		return this.toRLService<Models.IDataResponse<void>>("/api/Amortization/EditAmortizationModel").post(model).$promise;
	}

	createTemplateAmortizationModelAssociation(templateID: number, amortizationModelID: number) {
		var data = {
			templateID,
			amortizationModelID
		}
		return this.toRLService<Models.IDataResponse<void>>("/api/Amortization/CreateTemplateAmortizationModelAssociation").post(data).$promise;
	}

	getTemplateAmortizationModelAssociation(templateID: number) {
		var data = {
			templateID
		}
		return this.toRLService<Models.IDataResponse<number[]>>("/api/Amortization/GetTemplateAmortizationModelAssociation").post(data).$promise;
	}

	deleteTemplateAmortizationModelAssociation(templateID: number, amortizationModelID: number) {
		var data = {
			templateID,
			amortizationModelID
		}
		return this.toRLService<Models.IDataResponse<void>>("/api/Amortization/DeleteTemplateAmortizationModelAssociation").post(data).$promise;
	}

	updateTemplateAmortizationModelAssociation(templateID: number, amortizationModelIDs: number[]) {
		var data = {
			templateID,
			amortizationModelIDs
		}
		return this.toRLService<Models.IDataResponse<void>>("/api/Amortization/UpdateTemplateAmortizationModelAssociation").post(data).$promise;
    }

    getRightsDimensions() {
        return this.toRLService<Models.IDataResponse<Models.IRightsDimensions[]>>("/api/admin/GetRightsDimensions").get().$promise;
    }

    getSelectedRightsDimensions(systemIndicatorID: number) {
        var data = {
            systemIndicatorID: systemIndicatorID
        };
        return this.toRLService<Models.IDataResponse<Models.IRightsDimensions[]>>("/api/admin/getSelectedRightsDimensions").get(data).$promise;
    }

    updateSelectedRightsDimensions(updateRightsDimensions: Models.IRightsDimensions[]) {
        var data = {
            rightsDimensions: updateRightsDimensions
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/admin/updateSelectedRightsDimensions").post(data).$promise;
    }
}